import styled from '@emotion/styled';
import React from 'react';
import { Reveal } from '../../components/reveal/Reveal';
import { device } from '../../styles/devices';
import { standardTable } from '../../styles/mixins';
import { typography } from '../../styles/typography';

const Host = styled(Reveal)`
  ${standardTable('White', true)}

  width: 100%;
  table thead th {
    font-weight: bold;
    border-bottom: 1px solid ${(props) => props.theme.colors.primary};
    padding-bottom: 10px;

    font-family: ${(props) => props.theme.font.family};
    font-size: 12px;
    padding-left: 6px;
    text-align: left;
    @media ${device.tablet} {
      font-size: ${typography.sizes.bodySmallSize}px;
      padding-left: 0;
      text-align: center;
    }
  }
  table tbody tr > td {
    border-bottom: 1px solid ${(props) => props.theme.colors.primary};
    padding: 20px 0px;
  }
  > div > div > table {
    width: ${(props) => props.theme.pageWidth}px;
  }
  td {
    font-size: 24px;
    font-weight: 500;
    text-align: center;
    border-bottom: 1px solid ${(props) => props.theme.colors.primary};
    font-family: ${(props) => props.theme.font.familySlab};
    @media ${device.tablet} {
      font-size: ${typography.sizes.numbersMSize}px;
    }
  }

  tr > td:nth-child(2) {
    text-align: left;
  }

  tr > td:nth-child(2) > div {
    min-height: 135px;
    display: flex;
    align-items: center;
  }

  tr > td:nth-child(2) * {
    font-size: 14px;
  }

  tr > td:nth-child(1) * {
    font-size: 12px;
    @media ${device.tablet} {
      padding-right: inherit;
    }
  }

  tr > td:nth-child(2) strong {
    font-weight: 700;
    padding-bottom: 5px;
    display: block;
  }

  table tbody tr > td:first-child {
    width: 155px;
    padding-right: 12px;
    box-sizing: content-box;
    @media ${device.tablet} {
      padding-right: 88px;
    }
  }

  table thead th:first-child:after {
    content: initial;
  }
  tfoot td {
    border: 0;
    font-size: ${typography.sizes.bodySmallSize}px;
    padding-top: 15px;
    font-family: ${(props) => props.theme.font.family};
    font-weight: 400;
  }
`;

interface IProps {
  children: React.ReactNode;
}

export function TableWithImages({ children }: IProps) {
  return <Host>{children}</Host>;
}
